import { render, staticRenderFns } from "./TftUiBracketItem.vue?vue&type=template&id=ef717f1e&scoped=true"
import script from "./TftUiBracketItem.vue?vue&type=script&lang=js"
export * from "./TftUiBracketItem.vue?vue&type=script&lang=js"
import style0 from "./TftUiBracketItem.vue?vue&type=style&index=0&id=ef717f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef717f1e",
  null
  
)

export default component.exports